export default __webpack_public_path__ + "static/media/Lora-Medium.2dcdd425.ttf";